import React from "react";
import {
  Text as RNText,
  TextStyle,
  AccessibilityRole,
  StyleSheet,
} from "react-native";
import { TextProps } from "@xsolla/xui-primitives-core";

const roleMap: Record<string, AccessibilityRole> = {
  alert: "alert",
  heading: "header",
  button: "button",
  link: "link",
  text: "text",
};

const parseNumericValue = (
  value: string | number | undefined
): number | undefined => {
  if (value === undefined) return undefined;
  if (typeof value === "number") return value;
  const parsed = parseFloat(value);
  return isNaN(parsed) ? undefined : parsed;
};

export const Text: React.FC<TextProps> = ({
  children,
  color,
  fontSize,
  fontWeight,
  fontFamily,
  textAlign,
  lineHeight,
  numberOfLines,
  id,
  role,
  testID,
  "data-testid": dataTestId,
  style: styleProp,
  ...props
}) => {
  let resolvedFontFamily = fontFamily
    ? fontFamily.split(",")[0].replace(/['"]/g, "").trim()
    : undefined;

  if (
    resolvedFontFamily === "Pilat Wide" ||
    resolvedFontFamily === "Pilat Wide Bold" ||
    resolvedFontFamily === "Aktiv Grotesk"
  ) {
    resolvedFontFamily = undefined;
  }

  const incomingStyle = StyleSheet.flatten(styleProp) as TextStyle | undefined;

  const baseStyle: TextStyle = {
    color: color ?? incomingStyle?.color,
    fontSize: typeof fontSize === "number" ? fontSize : undefined,
    fontWeight: fontWeight as TextStyle["fontWeight"],
    fontFamily: resolvedFontFamily,
    textDecorationLine: props.textDecoration as TextStyle["textDecorationLine"],
    textAlign: textAlign ?? incomingStyle?.textAlign,
    lineHeight: parseNumericValue(lineHeight ?? incomingStyle?.lineHeight),
    marginTop: parseNumericValue(
      incomingStyle?.marginTop as number | string | undefined
    ),
    marginBottom: parseNumericValue(
      incomingStyle?.marginBottom as number | string | undefined
    ),
  };

  const accessibilityRole = role ? roleMap[role] : undefined;

  return (
    <RNText
      style={baseStyle}
      numberOfLines={numberOfLines}
      testID={dataTestId || testID || id}
      accessibilityRole={accessibilityRole}
    >
      {children}
    </RNText>
  );
};
